(() => {
  const selector = '.site-header .desktop-nav a, .site-header .mobile-menu a:not(.mobile-menu__cta)';
  const normalize = (url) => `${url.origin}${url.pathname.replace(/\/$/, '')}${url.hash === '#packs-pioupiou' ? '#offre' : url.hash}`;
  const select = (target = new URL(window.location.href)) => {
    const selected = normalize(target);
    document.querySelectorAll(selector).forEach((link) => {
      const destination = new URL(link.href, window.location.href);
      const active = normalize(destination) === selected;
      link.classList.toggle('is-selected', active);
      if (active) link.setAttribute('aria-current', destination.hash ? 'location' : 'page');
      else link.removeAttribute('aria-current');
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest(selector);
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    select(new URL(link.href, window.location.href));
  });
  window.addEventListener('hashchange', () => select());
  window.addEventListener('popstate', () => select());
  document.addEventListener('shopify:section:load', () => select());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => select(), { once: true });
  else select();
})();
